import { F as e, R as t, U as n, at as r, rt as i, t as a, v as o, w as s } from "./_plugin-vue_export-helper-CTQVpqU-.js";
//#region src/webcomponents/common/poi-design-system/Button.ce.vue?vue&type=script&setup=true&lang.ts
var c = ["aria-disabled"], l = /*#__PURE__*/ a(/* @__PURE__ */ s({
	__name: "Button.ce",
	props: {
		isDisabled: { type: Boolean },
		variant: {
			default: "primary",
			type: String
		}
	},
	setup(r, { expose: a }) {
		let s = n("button");
		function l(e) {
			r.isDisabled && e.stopPropagation();
		}
		function u() {
			s.value.focus();
		}
		return a({
			buttonElement: s,
			focus: u
		}), (n, a) => (e(), o("button", {
			ref: "button",
			"aria-disabled": r.isDisabled,
			class: i({
				"is-disabled": r.isDisabled,
				[r.variant]: !0
			}),
			type: "button",
			onClickCapture: l
		}, [t(n.$slots, "default", {}, void 0, !0)], 42, c));
	}
}), [["styles", ["button[data-v-1692febf]{color:#fff;border:none;border-radius:12px;padding:8px 24px;font-size:.875rem;font-weight:700}button.primary[data-v-1692febf]{cursor:pointer;background:#155dfc}button.primary[aria-disabled=true][data-v-1692febf]{opacity:.5;cursor:not-allowed}button.primary[data-v-1692febf]:hover:not([aria-disabled=true]){background:#0d3897}button.primary[data-v-1692febf]:focus:not([aria-disabled=true]){outline-offset:-3px;background:#0d3897;border-radius:12px;outline:1px solid #fafafa}button.primary[data-v-1692febf]:active:not([aria-disabled=true]){background:#041332;outline:none}button.primary-bis[data-v-1692febf]{cursor:pointer;background:#141514}button.primary-bis[aria-disabled=true][data-v-1692febf]{opacity:.5;cursor:not-allowed}button.primary-bis[data-v-1692febf]:hover:not([aria-disabled=true]){background:#3d3e3d}button.primary-bis[data-v-1692febf]:focus:not([aria-disabled=true]){outline-offset:-3px;background:#3d3e3d;border-radius:12px;outline:1px solid #fafafa}button.primary-bis[data-v-1692febf]:active:not([aria-disabled=true]){background:#dcdddc;outline:none}button.secondary[data-v-1692febf]{color:#155dfc;cursor:pointer;background:#fff;border:2px solid #155dfc}button.secondary[aria-disabled=true][data-v-1692febf]{opacity:.5;cursor:not-allowed}button.secondary[data-v-1692febf]:hover:not([aria-disabled=true]){background:#d0dffe}button.secondary[data-v-1692febf]:focus:not([aria-disabled=true]){outline-offset:-4px;background:#d0dffe;border-radius:12px;outline:1px solid #155dfc}button.secondary[data-v-1692febf]:active:not([aria-disabled=true]){color:#fff;background:#155dfc;outline:none}"]], ["__scopeId", "data-v-1692febf"]]), u = /*#__PURE__*/ a(/* @__PURE__ */ s({
	__name: "Icon.ce",
	props: { backgroundColor: { type: String } },
	setup(n) {
		return (i, a) => (e(), o("div", {
			style: r({ "--background-color": n.backgroundColor }),
			"aria-hidden": "true",
			class: "rounded-icon"
		}, [t(i.$slots, "default", {}, void 0, !0)], 4));
	}
}), [["styles", [".rounded-icon[data-v-27f5c215]{background-color:var(--background-color);aspect-ratio:1;border-radius:50%;align-items:center;width:fit-content;padding:8px;display:flex}"]], ["__scopeId", "data-v-27f5c215"]]);
//#endregion
export { l as n, u as t };
